
import { mapGetters } from 'vuex'

export default {
  props: {
    filterOptions: {
      default: () => {
        return {
          showCategory: false,
          showLang: false,
          showSort: false,
          showSearch: false,
        }
      },
    },
  },
  data() {
    return {
      filter: {
        categoryId: -1,
        search: '',
        lang: '',
        sort: '',
      },
      langs: [
        { code: 'tr', text: this.$custom$t('language.tr') },
        { code: 'en', text: this.$custom$t('language.en') },
      ],
      sorts: [
        { code: 'title-asc', text: this.$custom$t('sort.azName') },
        { code: 'title-desc', text: this.$custom$t('sort.zaName') },
        { code: 'price-asc', text: this.$custom$t('sort.lhPrice') },
        { code: 'price-desc', text: this.$custom$t('sort.hlPrice') },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getCategories: 'categories/getCategories',
    }),
  },
  methods: {
    SET_QUERY() {
      const query = this.$route.query
      if (!isNaN(Number(query.page))) this.filter.page = query.page
      if (query.q) this.filter.search = query.q
      if (query.sort) this.filter.sort = query.sort
      if (query.lang) this.filter.lang = query.lang
      if (!isNaN(Number(query.categoryId)))
        this.filter.categoryId = query.categoryId
    },
  },
  created() {
    this.SET_QUERY()
  },
}
